import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { AppInfoService } from '../../../../shared/services/app-info.service';
import { CustomElementHostComponent, CustomElementHostComponentProps } from '../../components/custom-element-host/custom-element-host.component';

@Component({
  selector: 'app-custom-element-host-page',
  template: `<app-custom-element-host [props]="props()" class="h-full w-full overflow-auto"></app-custom-element-host><router-outlet />`,
  imports: [
    CustomElementHostComponent,
    RouterOutlet,
  ]
})
export class CustomElementHostPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly appInfo = inject(AppInfoService);
  props = signal<{ tagName: string; scriptPath: string; manifestSource: string }>(null);

  constructor() {
    const { tagName, scriptPath, manifestSource } = this.route.snapshot.data as CustomElementHostComponentProps;
    this.props.set({ tagName, scriptPath, manifestSource });
    if (tagName) {
      this.appInfo.ActiveViewName.next(tagName);
    }
  }
}
